import React from 'react';
import { Chip } from '@mui/material';
import { IndicatorStatus } from '../../../services/indicatorRegistryApi';

const STYLE: Record<IndicatorStatus, { label: string; color: 'default' | 'warning' | 'success' }> = {
  draft: { label: 'Draft', color: 'default' },
  in_review: { label: 'In review', color: 'warning' },
  approved: { label: 'Approved', color: 'success' },
  retired: { label: 'Retired', color: 'default' },
};

const StatusChip: React.FC<{ status: IndicatorStatus }> = ({ status }) => (
  <Chip
    size="small"
    label={STYLE[status].label}
    color={STYLE[status].color}
    variant={status === 'retired' ? 'outlined' : 'filled'}
    sx={{ height: 22 }}
  />
);

export default StatusChip;
